<template>
	<div>
		<!-- <com-back name="Renovar la tarjeta bancaria"></com-back> -->
		<div class="wrapper">
			<div class="bank" :class="{ activeBottomTitle: activeBottomTitle == 1 }" @click="handleBottomTitle(1)">
				<div @click="handleSelect" class="select">
					<span>{{ cardInfoData.bank_name }}</span>
					<img src="@/assets/image/internal/payment/banca_right.png" alt="" class="banca_right" />
				</div>
				<ul v-show="selectShow">
					<div style="height: 2rem; overflow-y: auto;">
						<li
							v-for="item in jsonData"
							:key="item.bankId"
							@click="handleClick(item)"
							:style="{
								background: item.bankId == optionIndex ? '#DEE2E7' : '',
							}"
						>
							<img src="@/assets/image/internal/payment/pse.png" class="pse_img" />
							{{ item.bankName }}
						</li>
					</div>
				</ul>
			</div>
			<!-- <div class="tipo">
        <div>Tipo de cuenta</div>
        <van-radio-group v-model="cardInfoData.bank_card_type">
          <van-radio :name="1" checked-color="#8533D9">Ahorros</van-radio>
        <van-radio name="2" checked-color="#2B3550">Corriente</van-radio> 
        </van-radio-group>
      </div> -->
			<div class="tipo">
				<div>Ingresar el número de cuenta bancaria</div>
				<input
					type="text"
					v-model="cardInfoData.bank_no"
					class="bank"
					@input="handleInput(cardInfoData.bank_no)"
					:class="{ activeBottomTitle: activeBottomTitle == 2 }"
					@click="handleBottomTitle(2)"
				/>
				<div v-if="autoMobile == 1" class="tips_bg" @click="setTipsVal">{{ tipsMobile }}</div>
			</div>
			<div class="tipo">
				<div>Confirmar el número de cuanta bancaria</div>
				<input
					type="text"
					v-model="confirmar"
					class="bank"
					@input="handleInputConfirmar(confirmar)"
					@click="handleBottomTitle(3)"
					:class="{ activeBottomTitle: activeBottomTitle == 3 }"
				/>
			</div>
			<div class="por">
				Por favor vincula su cuenta bancaria registrada con su núnero de cédula, y no use las tarjetas bancarias de
				otros para evitar la falla del préstamo.
				<img src="@/assets/image/internal/payment/tishi.webp" alt="" />
			</div>
			<button @click="handleButton" class="wrapper_button">CONTINUAR</button>
			<!-- otp verification -->
			<van-overlay :show="showDialog">
				<div class="dialog" @click.stop>
					<h1>Código de Verificación</h1>
					<div class="flex">
						<img src="@/assets/image/internal/payment/dialog_one.webp" alt="" />
						<input type="text" v-model="mobile" disabled />
					</div>
					<div class="flex">
						<div class="left">
							<img src="@/assets/image/internal/payment/dialog_two.webp" alt="" />
							<input v-model="code" :maxlength="4" @focus="handleCodeInput" />
						</div>
						<button v-if="disabled">{{ butNum }}s</button>
						<button @click="getSmsCode" v-else>Enviar</button>
					</div>
					<div class="small_title" v-show="tip">Reenviar el Código</div>
					<button @click="handleDialogConfirm" class="comfirmButton">
						CONFIRMAR
					</button>
					<div class="cerrar" @click="handleDialogCerrar">Cerrar</div>
				</div>
			</van-overlay>
			<!-- Confirm Popup -->
			<van-dialog
				v-model="confirmarShow"
				show-cancel-button
				class="dialog confirmarDialog"
				confirm-button-text="Confirmar"
				cancel-button-text="Modificar"
				@confirm="handleConfirmar"
				@cancel="handleCancel"
			>
				<p>
					Por favor confirme que el numero desu tarjeta bancaria proporcionado escorrecto.
				</p>
				<div class="num">{{ confirmar }}</div>
			</van-dialog>
		</div>
	</div>
</template>
<script>
	// import jsonData from './bank.json'
	import common from '@/mixins/common.js'
	import { getQueryVariable } from '@/utils/internal'
	// import comBack from "@/components/internal/back.vue";
	import Bus from '@/utils/bus'
	export default {
		mixins: [common],
		data() {
			return {
				showDialog: false,
				code: null,
				mobile: '',
				tip: false,
				jsonData: [],
				optionIndex: '',
				selectShow: false,
				butNum: 60,
				disabled: false,
				confirmarShow: false,
				cardInfoData: {
					bank_card_type: 1,
					bank_no: '',
				},
				confirmar: '',
				activeBottomTitle: null,
				confirmarShowFalse: null,
				autoMobile: 0,
				tipsMobile: '',
			}
		},
		components: {
			// comBack,
		},
		mounted() {
			this.mobile = '+' + this.$route.query.mobile?.replace(' ', '')?.replace('+', '')
			this.getAccessToken()
			this.getApiHead()
			this.getInfo()
			window.android.showTitle()
			document.title = 'Modificar'
		},

		methods: {
			getQueryVariable,

			setTipsVal() {
				this.handleInput(this.tipsMobile)
				this.handleInputConfirmar(this.tipsMobile)
				this.autoMobile = 0
			},
			//Add background color
			handleBottomTitle(value) {
				this.activeBottomTitle = value
			},
			//inquiry personal information
			getInfo() {
				this.$axios
					.post(this.apiHeadGatewayVh + 'account/info/get', {
						...this.params,
						show_dialog: 0,
						app_version_code: window.android?.getAppVersionCode() || 59,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.cardInfoData = res.data.data.account_profile.card_info
							this.tipsMobile = res.data.data.my_phone?.replace('+57', '')
							this.handleInput(this.cardInfoData.bank_no)
							this.handleInputConfirmar(this.cardInfoData.bank_no)
						}
					})
			},
			//Dropdown Bank List
			handleSelect() {
				this.selectShow = !this.selectShow
				this.handleBottomTitle(1)
				if (this.selectShow) {
					this.$axios
						.post(this.apiHeadGatewayVh + 'payment/india/bank/list', {
							...this.params,
						})
						.then((res) => {
							if (res.data.code == 0) {
								this.jsonData = res.data.data.bankList
							}
						})
				}
			},
			//Select Bank
			handleClick(item) {
				let { bankId, bankName, autoMobile } = item
				this.optionIndex = bankId
				this.cardInfoData.bank_name = bankName
				this.autoMobile = autoMobile
				this.selectShow = false
			},
			//Not allowed to input non numeric characters and display in 4 groups
			handleInput(value) {
				this.cardInfoData.bank_no = value.replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1 ')
			},
			handleInputConfirmar(value) {
				this.confirmar = value.replace(/\D/g, '').replace(/(\d{4})(?=\d)/g, '$1 ')
			},
			handleCodeInput() {
				this.tip = false
			},
			//Obtain verification code
			getSmsCode() {
				this.disabled = true
				let setTe = setInterval(() => {
					this.butNum--
					if (this.butNum == 0) {
						clearInterval(setTe)
						this.disabled = false
						this.butNum = 60
					}
				}, 1000)
				if (this.butNum == 60) {
					let formData = new FormData()
					formData.append('mobile', this.mobile)
					formData.append('source', this.params.source)
					this.$axios.post(this.apiHead + 'h5/v2/auth/sms_code', formData).then((res) => {
						if (res.data.code != 0) {
							this.tip = true
							if (res.data.code == 400213) {
								this.$toast('El número de teléfono no está registrado, por favor vuelva a ingresar')
							}
						}
					})
				}
			},
			//click ok
			handleButton() {
				if (this.cardInfoData.bank_no == '') {
					return this.$toast('Por favor ingrese el número de cuente')
				} else if (this.confirmar == '') {
					return this.$toast('Por favor confirme el número de cuenta bancaria')
				} else if (this.cardInfoData.bank_no != this.confirmar) {
					return this.$toast('Los dos números de tarjeta bancaria no se coinciden, por favor vuelva a ingresar')
				} else if (
					this.cardInfoData.bank_name.toLowerCase().includes('nequi') &&
					this.confirmar.replace(/\s+/g, '').length != 10
				) {
					return this.$toast('Por favor ingrese el número de tarjetabancaria de 10números')
				} else {
					if (this.confirmarShowFalse == 1) {
						this.confirmarShow = true
					} else {
						this.showDialog = true
					}
					this.code = null
					this.tip = false
				}
			},
			handleDialogCerrar() {
				this.showDialog = false
			},
			//otp Verification confirmation
			handleDialogConfirm() {
				this.$axios
					.post(this.apiHead + 'api/v8/h5/auth/otp/sms', {
						auth_code: this.code,
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.confirmarShow = true
							this.showDialog = false
						} else {
							this.tip = true
						}
					})
			},
			//Confirm Popup
			handleConfirmar() {
				this.$axios
					.post(this.apiHead + 'api/v8/h5/account/bank/card/update', {
						bank_card_type: '1',
						bank_name: this.cardInfoData.bank_name,
						bank_no: this.confirmar.replace(/ /g, ''),
						...this.params,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.confirmarShow = false
							Bus.$emit('change-bank', this.confirmar.replace(/ /g, ''))
							window.android?.pop()
							// this.$router.push({ path: 'calculation' })
						}
					})
			},
			//Cancel Popup
			handleCancel() {
				this.confirmarShowFalse = 1
				this.confirmarShow = false
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import '@/assets/style/internal/payment/banca.scss';
	@import '@/assets/style/internal/toast.scss';
</style>
